import { createHttpLink, from } from '@apollo/client/core'
import type { ApolloClient } from '@apollo/client/core'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import { provideApolloClient } from '@vue/apollo-composable'

export default defineNuxtPlugin((nuxtApp) => {
  const { graphqlUri } = useRuntimeConfig().public

  const { CUSTOMER_TOKEN, HEADER_LANGS } = useAppConfig()

  const $apollo = nuxtApp.$apollo as { defaultClient: ApolloClient<unknown> }

  let token = useCookie(CUSTOMER_TOKEN)

  const { $i18n } = useNuxtApp()

  const headerLang = {
    [HEADER_LANGS.name]: (HEADER_LANGS.list as Record<string, string>)[$i18n.locale.value as string],
  }

  const errorLink = onError((err) => {
    nuxtApp.callHook('apollo:error', err)
  })

  const authLink = setContext(async (_, { headers }) => {
    if (process.client)
      token = useCookie(CUSTOMER_TOKEN)

    const newHeader = {
      headers: {
        ...headers,
        ...headerLang,
      },
    }
    if (token.value)
      newHeader.headers.Authorization = token.value

    return newHeader
  })

  const httpLink = createHttpLink({
    uri: graphqlUri,
    credentials: 'include',
  })

  $apollo.defaultClient.defaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

  $apollo.defaultClient.setLink(from([authLink, errorLink, httpLink]))

  provideApolloClient($apollo.defaultClient)
})
